/**
 * Create mini cart context for custom hook
 */

import { createContext } from 'react'

const MiniCartContext = createContext({
  availableCarts: [],
  cart: [],
  cartCurrency: {},
  cartLineItems: [],
  cartPriceSummary: {},
  loadings: [],
  miniCartOpen: false,
  orderMethodMandatory: true,
  totalItems: '',
  skusUnavailableToCheckout: [],
  setIsActive: false,
  openMiniCart: () => {},
  closeMiniCart: () => { },
  getCartValidationErrors: () => {},
  onCartChange: () => {},
  onUpdateCartLineQuantity: () => {},
  onRemoveCartLine: () => {},
  onRequestRefreshCart: () => {},
  onRequestCheckout: () => {},
  onSelectedCommerceChannelChange: () => {},
})

export default MiniCartContext
